<!--
    Styles
-->

<style scoped>

    .marker {
        padding: 6px 8px;
        max-width: 120px;
    }

</style>



<!--
    Template
-->

<template>
    <div class="marker" v-show="station.sum">
        <p class="t15 u-cut w7">{{ station.name }}</p>
        <p class="t12 u-cut">
            <span class="w7 cl-orange">{{ station.sum }}件</span>
            <span>該当中</span>
        </p>
    </div>
</template>



<!--
    Scripts
-->

<script>

    export default {

        props: [
            'station'
        ]

    }

</script>

